import sliderStyles from "@/components/common/styles/slider.module.scss";
import React, { useEffect, useState } from "react";

interface StyledSliderProps {
  min: number;
  max: number;
  step: number;
  value: number;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}
const StyledSlider = ({
  min,
  max,
  step,
  value,
  onChange,
}: StyledSliderProps) => {
  const [style, setStyle] = useState<React.CSSProperties>();

  useEffect(() => {
    const getBackgroundStyle = () => {
      const percentage = ((value - min) / (max - min)) * 100;

      return {
        background: `linear-gradient(to right, #FF5722 ${percentage}%, #3F3F3F ${percentage}%)`,
      };
    };

    setStyle(getBackgroundStyle());
  }, [value, min, max]);

  return (
    <input
      className={sliderStyles.slider}
      type="range"
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      value={value}
      style={style}
    />
  );
};

export default StyledSlider;
